<template>
    <div v-if="loaded">
    
        <form class="signup_form" @submit.prevent="$emit('next', formData)" v-if="loaded">
          <ul>
              <div class="part">
                  <li>
                      <label>טלפון משרדי החברה</label>
                      <input type="text" v-model="formData.company_office_phone"  >
                  </li>
                  <li>
                      <label>טלפון נייד של איש הקשר בחברה</label>
                      <input type="text" v-model="formData.phone_company_contact"   >
                  </li>
                  <li>
                      <label>כתובת החברה</label>
                      <input type="text" v-model="formData.company_address"   >
                  </li>
              </div>
              <div class="part">
                  <li>
                      <label>בורסאי?</label>
                      <div class="switch_container">
                          <span>לא</span>
                          <div class="onoffswitch">
                              <input type="checkbox" v-model="formData.is_borsoy"  name="onoffswitch-a" id="onoffswitch-b" class="onoffswitch-checkbox"  tabindex="0">
                              <label for="onoffswitch-b" class="onoffswitch-label"></label>
                          </div>
                          <span>כן</span>
                      </div>
                  </li>
                  <div class="inline gap_mid">
                      <li>
                          <label>האם יש סיווג קבלני?</label>
                          <div class="switch_container">
                              <span>לא</span>
                              <div class="onoffswitch">
                                  <input type="checkbox" v-model="formData.is_contractor_classification"  name="onoffswitch-a" id="onoffswitch-a" class="onoffswitch-checkbox"  tabindex="0">
                                  <label for="onoffswitch-a" class="onoffswitch-label"></label>
                              </div>
                              <span>כן</span>
                          </div>
                      </li>
                      <li>
                          <label>האם החברה פועלת גם כחברת ביצוע?</label>
                          <div class="switch_container">
                              <span>לא</span>
                              <div class="onoffswitch">
                                  <input type="checkbox" v-model="formData.is_contractor_execution"  name="onoffswitch-is_contractor_execution" id="onoffswitch-is_contractor_execution" class="onoffswitch-checkbox"  tabindex="0">
                                  <label for="onoffswitch-is_contractor_execution" class="onoffswitch-label"></label>
                              </div>
                              <span>כן</span>
                          </div>
                      </li>
                  </div>
                  <li>
                      <label>סוג הסיווג</label>
                      <select v-model="formData.classification_type" >
                          <option value="">בחירה מתוך הרשימה</option>
                          <option v-for="item in $store.classification_type" :key="item.id" :value="item.id" >{{ item.name }}</option>
                      </select>
                  </li>
                  <li>
                    <GalleryInput  v-model="formData.classification_type_file" :max="1" @onUpload="handleUpload" />	
        
                      <span class="helper_text">יש להעלות קובץ מסוג PDF המאשר את סוג הסיווג</span>
                  </li>
              </div>
              <div class="part">
                  <li>
                      <label>קישור לאתר החברה</label>
                      <input type="text" v-model="formData.link_company_site"  >
                  </li>
              </div>
              <input v-if="state != 'edit'" type="submit" class="btn" value="המשך">
          </ul>
        </form>
    </div>
</template>

<script>
import GalleryInput from '../GalleryInput.vue';

export default {
    props: ["updatedData", "state"],
    components: {GalleryInput},
    data() {
        return {
            loaded: false,
            list:[],
            formData: {
                company_office_phone: '',
                phone_company_contact: '',
                company_address: '',
                is_contractor_classification: false,
                classification_type: '',
                classification_type_file: '',
                link_company_site: '',
                is_borsoy: '',
                step: 2
            },
        }
    },
    mounted() {
       

        if (this.updatedData) {
            for (const key in this.formData) {
                if (this.updatedData[key]) this.formData[key] = this.updatedData[key];
            }
            this.formData.is_borsoy = Boolean(+this.formData?.is_borsoy)
            this.loaded = true;
        }
        
    },
    methods: {
        handleUpload(data) {
            if (data && data.id) {
                this.formData.classification_type_file = data.id; 
            }
        },
    },
    watch: {
        formData: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        }
    }
}
</script>

<style>

</style>